enum productConstants {
  ALL = '/coach-product',
  SESSION = '/sessions',
  ASSESSMENTS = '/assessments',
  PACKAGES = '/packages',
  PRODUCTS = '/coach-product',
  ACCEPT_REJECT = '/coach-product/review',
}
export default productConstants;
